import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
export default function AboutPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');
  const [formSubmitting, setFormSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormSubmitted(true);
      form.reset();
      return;
    }

    setFormSubmitting(true);
    try {
      const formData = new FormData(form);
      if (honeypotEl) formData.delete('phone_alt');

      const response = await fetch('https://readdy.ai/api/form/d9rh0r6e3oq4jqumu190', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (
        response.ok &&
        parsed?.code === 'OK'
      ) {
        setFormSubmitted(true);
        form.reset();
      } else {
        setFormError(
          serverMsg && !serverMsg.includes('spam') && !serverMsg.includes('form data is spam')
            ? serverMsg
            : '提交失败，请稍后再试。'
        );
      }
    } catch {
      setFormError('网络错误，请检查连接后重试。');
    } finally {
      setFormSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-4">
              关于我们
            </h1>
          </div>
        </div>

        <section className="py-14 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                品牌介绍
              </h2>
              <div className="prose prose-lg max-w-none prose-p:text-foreground-700 prose-p:leading-relaxed">
                <p>
                  <strong>案件深度分析</strong>是一个专注于重大社会案件深度解读的专业资讯平台。我们致力于为读者提供全面、客观、专业的案件资讯与分析，帮助公众理解复杂法律案件背后的社会议题。
                </p>
                <p>
                  我们相信，每一个重大案件都是一面社会镜子——它不仅反映了个体的行为选择，更折射出制度设计、文化传统和社会心理的深层结构。通过深度分析，我们希望引导读者超越简单的道德评判，进入理性的社会思考。
                </p>
                <p>
                  我们的编辑团队由法律学者、社会学家、资深记者和性别研究专家组成，确保每篇文章兼具专业深度与可读性。我们坚持独立、客观的编辑方针，不接受任何可能影响内容公正性的商业合作。
                </p>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                编辑理念
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '客观严谨',
                    desc: '所有分析均基于公开的司法文件、学术研究和权威媒体报导，杜绝臆测和煽情。',
                  },
                  {
                    icon: 'ri-lightbulb-line',
                    title: '深度洞察',
                    desc: '超越案件本身，探索制度、文化和社会心理层面的深层议题。',
                  },
                  {
                    icon: 'ri-heart-line',
                    title: '人文关怀',
                    desc: '关注案件中的个体命运，尊重受害者隐私，倡导性别平等与社会正义。',
                  },
                ].map((item) => (
                  <div
                    key={item.title}
                    className="bg-background-100 rounded-lg p-6 border border-background-200/70"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                声誉与责任
              </h2>
              <div className="prose prose-lg max-w-none prose-p:text-foreground-700 prose-p:leading-relaxed">
                <p>
                  自创立以来，<strong>案件深度分析</strong>始终将社会责任置于商业利益之上。我们深知，报导性别暴力和社会案件是一份沉重的工作——每一个文字都可能影响公众认知、受害者感受乃至司法进程。
                </p>
                <p>
                  我们的内容获得了学术界、法律界和媒体同行的广泛认可。多篇文章被大学课堂引用为教学案例，部分分析报告被立法机构参考用于修法讨论。这些认可既是对我们工作的肯定，也提醒我们肩上的责任更加重大。
                </p>
                <p>
                  如果您对我们的内容有任何意见或建议，欢迎通过以下方式与我们联系。我们珍视每一位读者的反馈。
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                联系我们
              </h2>
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
                <div className="lg:col-span-2 space-y-5">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                      <p className="text-sm text-foreground-600">contact@case-analysis.tw</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">办公地址</p>
                      <p className="text-sm text-foreground-600">台湾台北市信义区</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">工作时间</p>
                      <p className="text-sm text-foreground-600">周一至周五 09:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <div className="lg:col-span-3">
                  <div className="bg-background-100 rounded-lg border border-background-200/70 p-6">
                    <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-5">
                      发送消息
                    </h3>

                    {formSubmitted ? (
                      <div className="bg-accent-100/80 border border-accent-300/60 rounded-lg p-5 text-center">
                        <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-200 text-accent-700">
                          <i className="ri-check-line text-xl"></i>
                        </div>
                        <p className="text-foreground-800 font-medium">感谢您的来信！</p>
                        <p className="text-sm text-foreground-600 mt-1">我们会在1-2个工作日内回复。</p>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit} data-readdy-form="">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                          <div>
                            <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                              姓名
                            </label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              required
                              className="w-full px-3.5 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-800"
                              placeholder="请输入您的姓名"
                            />
                          </div>
                          <div>
                            <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                              电子邮箱
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              required
                              className="w-full px-3.5 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-800"
                              placeholder="请输入您的邮箱"
                            />
                          </div>
                        </div>
                        <div className="mb-4">
                          <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            主题
                          </label>
                          <input
                            type="text"
                            id="subject"
                            name="subject"
                            required
                            className="w-full px-3.5 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-800"
                            placeholder="请输入主题"
                          />
                        </div>
                        <div className="mb-4">
                          <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            留言内容
                          </label>
                          <textarea
                            id="message"
                            name="message"
                            required
                            rows={4}
                            maxLength={500}
                            className="w-full px-3.5 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-800 resize-none"
                            placeholder="请输入您的留言（最多500字）"
                          ></textarea>
                          <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                        </div>

                        <input
                          type="text"
                          name="phone_alt"
                          tabIndex={-1}
                          autoComplete="off"
                          aria-hidden="true"
                          readOnly
                          className="absolute opacity-0 pointer-events-none"
                          style={{ position: 'absolute', left: '-9999px', top: '-9999px', width: '1px', height: '1px' }}
                        />

                        {formError && (
                          <div className="mb-4 p-3 bg-accent-100/70 border border-accent-300/60 rounded-md text-sm text-accent-800">
                            {formError}
                          </div>
                        )}

                        <button
                          type="submit"
                          disabled={formSubmitting}
                          className="w-full sm:w-auto bg-primary-500 text-background-50 dark:text-foreground-950 px-6 py-2.5 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
                        >
                          {formSubmitting ? '发送中...' : '发送消息'}
                        </button>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于我们 — 案件深度分析',
              description:
                '案件深度分析是一个专注于重大社会案件深度解读的专业资讯平台，致力于为读者提供全面、客观、专业的案件资讯与分析。',
              url: 'https://lizongrui-case-analysis.readdy.ai/about',
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}